<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { EditorState } from "@common/Common";
    import { CreateExpenseAccountEventPayload, ExpenseAccountEditorViewModel, UpdateCostAccountEventPayload } from "@Quest/Financials/Costs/Components/ExpenseAccountEditor";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ExpenseAccountEditor extends Vue
    {
        get vm(): ExpenseAccountEditorViewModel { return this.$props.viewModel as ExpenseAccountEditorViewModel; }
        get opened(): boolean { return this.vm?.opened; }
        get confirmButtonLabel(): string { return this.vm.state === EditorState.Creator ? 'Create' : 'Update'; }
        get modalTitle(): string { return this.vm.state === EditorState.Creator ? 'New expense account' : 'Edit the cost account'; }
        get canEditName(): boolean { return this.vm.canEditName; }
        get canEditClassification(): boolean { return this.vm.canEditClassification; }
        get subtotals() { return this.vm.subtotals; }

        get name(): string | null { return this.vm.name; }
        set name(val: string | null) { this.vm.name = val; }

        get classification(): string | null { return this.vm.classification; }
        set classification(val: string | null) { this.vm.classification = val; }

        get subtotalId(): string | null { return this.vm.subtotalId; }
        set subtotalId(val: string | null) { this.vm.subtotalId = val; }


        handleFormSubmit()
        {
            if (this.vm.state === EditorState.Creator)
            {
                this.$emit("create-expense", new CreateExpenseAccountEventPayload(this.name, this.classification, this.subtotalId));

            }
            else if (this.vm.state === EditorState.Editor)
            {
                this.$emit("update-cost", new UpdateCostAccountEventPayload(this.vm.id, this.name, this.classification, this.subtotalId));
            }
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalTitle }}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="expense-account-editor-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input type="text" v-if="canEditName" v-model.trim="name" class="form-control" required maxlength="100" minlength="2" />
                                <input type="text" v-if="!canEditName" v-model="name" class="form-control" readonly />
                            </div>
                            <div class="form-group">
                                <label for="subtotal">Subtotal:</label>
                                <select id="subtotal" v-model="subtotalId" class="form-control">
                                    <option :value="null">None</option>
                                    <option v-for="s in subtotals" :value="s.Id">{{s.Name}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="classification">Classification:</label>
                                <select v-if="canEditClassification" id="classification" v-model="classification" class="form-control">
                                    <option value="OpEx">OpEx</option>
                                    <option value="COGS">COGS</option>
                                    <option value="Other">Other expenses</option>
                                </select>
                                <input v-else type="text" readonly v-model="classification" class="form-control" />
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close"  class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="expense-account-editor-form" class="btn btn-primary">{{ confirmButtonLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>